export default "__VITE_ASSET__BGaCj_ho__"